export const countryList = [
  { name: "Taiwan (台灣)", iso2: "TW", dialCode: "886", preferred: true },
  { name: "Afghanistan (‫افغانستان‬‎)", iso2: "AF", dialCode: "93" },
  { name: "Albania (Shqipëri)", iso2: "AL", dialCode: "355" },
  { name: "Algeria (‫الجزائر‬‎)", iso2: "DZ", dialCode: "213" },
  { name: "American Samoa", iso2: "AS", dialCode: "1684" },
  { name: "Andorra", iso2: "AD", dialCode: "376" },
  { name: "Angola", iso2: "AO", dialCode: "244" },
  { name: "Anguilla", iso2: "AI", dialCode: "1264" },
  { name: "Antigua and Barbuda", iso2: "AG", dialCode: "1268" },
  { name: "Argentina", iso2: "AR", dialCode: "54" },
  { name: "Armenia (Հայաստան)", iso2: "AM", dialCode: "374" },
  { name: "Aruba", iso2: "AW", dialCode: "297" },
  { name: "Australia", iso2: "AU", dialCode: "61" },
  { name: "Austria (Österreich)", iso2: "AT", dialCode: "43" },
  { name: "Azerbaijan (Azərbaycan)", iso2: "AZ", dialCode: "994" },
  { name: "Bahamas", iso2: "BS", dialCode: "1242" },
  { name: "Bahrain (‫البحرين‬‎)", iso2: "BH", dialCode: "973" },
  { name: "Bangladesh (বাংলাদেশ)", iso2: "BD", dialCode: "880" },
  { name: "Barbados", iso2: "BB", dialCode: "1246" },
  { name: "Belarus (Беларусь)", iso2: "BY", dialCode: "375" },
  { name: "Belgium (België)", iso2: "BE", dialCode: "32" },
  { name: "Belize", iso2: "BZ", dialCode: "501" },
  { name: "Benin (Bénin)", iso2: "BJ", dialCode: "229" },
  { name: "Bermuda", iso2: "BM", dialCode: "1441" },
  { name: "Bhutan (འབྲུག)", iso2: "BT", dialCode: "975" },
  { name: "Bolivia", iso2: "BO", dialCode: "591" },
  {
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    iso2: "BA",
    dialCode: "387"
  },
  { name: "Botswana", iso2: "BW", dialCode: "267" },
  { name: "Brazil (Brasil)", iso2: "BR", dialCode: "55" },
  { name: "British Indian Ocean Territory", iso2: "IO", dialCode: "246" },
  { name: "British Virgin Islands", iso2: "VG", dialCode: "1284" },
  { name: "Brunei", iso2: "BN", dialCode: "673" },
  { name: "Bulgaria (България)", iso2: "BG", dialCode: "359" },
  { name: "Burkina Faso", iso2: "BF", dialCode: "226" },
  { name: "Burundi (Uburundi)", iso2: "BI", dialCode: "257" },
  { name: "Cambodia (កម្ពុជា)", iso2: "KH", dialCode: "855" },
  { name: "Cameroon (Cameroun)", iso2: "CM", dialCode: "237" },
  { name: "Canada", iso2: "CA", dialCode: "1" },
  { name: "Cape Verde (Kabu Verdi)", iso2: "CV", dialCode: "238" },
  { name: "Caribbean Netherlands", iso2: "BQ", dialCode: "599" },
  { name: "Cayman Islands", iso2: "KY", dialCode: "1345" },
  {
    name: "Central African Republic (République centrafricaine)",
    iso2: "CF",
    dialCode: "236"
  },
  { name: "Chad (Tchad)", iso2: "TD", dialCode: "235" },
  { name: "Chile", iso2: "CL", dialCode: "56" },
  { name: "China (中国)", iso2: "CN", dialCode: "86" },
  { name: "Christmas Island", iso2: "CX", dialCode: "61" },
  { name: "Cocos (Keeling) Islands", iso2: "CC", dialCode: "61" },
  { name: "Colombia", iso2: "CO", dialCode: "57" },
  { name: "Comoros (‫جزر القمر‬‎)", iso2: "KM", dialCode: "269" },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    iso2: "CD",
    dialCode: "243"
  },
  { name: "Congo (Republic) (Congo-Brazzaville)", iso2: "CG", dialCode: "242" },
  { name: "Cook Islands", iso2: "CK", dialCode: "682" },
  { name: "Costa Rica", iso2: "CR", dialCode: "506" },
  { name: "Côte d’Ivoire", iso2: "CI", dialCode: "225" },
  { name: "Croatia (Hrvatska)", iso2: "HR", dialCode: "385" },
  { name: "Cuba", iso2: "CU", dialCode: "53" },
  { name: "Curaçao", iso2: "CW", dialCode: "599" },
  { name: "Cyprus (Κύπρος)", iso2: "CY", dialCode: "357" },
  { name: "Czech Republic (Česká republika)", iso2: "CZ", dialCode: "420" },
  { name: "Denmark (Danmark)", iso2: "DK", dialCode: "45" },
  { name: "Djibouti", iso2: "DJ", dialCode: "253" },
  { name: "Dominica", iso2: "DM", dialCode: "1767" },
  {
    name: "Dominican Republic (República Dominicana)",
    iso2: "DO",
    dialCode: "1"
  },
  { name: "Ecuador", iso2: "EC", dialCode: "593" },
  { name: "Egypt (‫مصر‬‎)", iso2: "EG", dialCode: "20" },
  { name: "El Salvador", iso2: "SV", dialCode: "503" },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    iso2: "GQ",
    dialCode: "240"
  },
  { name: "Eritrea", iso2: "ER", dialCode: "291" },
  { name: "Estonia (Eesti)", iso2: "EE", dialCode: "372" },
  { name: "Ethiopia", iso2: "ET", dialCode: "251" },
  { name: "Falkland Islands (Islas Malvinas)", iso2: "FK", dialCode: "500" },
  { name: "Faroe Islands (Føroyar)", iso2: "FO", dialCode: "298" },
  { name: "Fiji", iso2: "FJ", dialCode: "679" },
  { name: "Finland (Suomi)", iso2: "FI", dialCode: "358" },
  { name: "France", iso2: "FR", dialCode: "33" },
  { name: "French Guiana (Guyane française)", iso2: "GF", dialCode: "594" },
  {
    name: "French Polynesia (Polynésie française)",
    iso2: "PF",
    dialCode: "689"
  },
  { name: "Gabon", iso2: "GA", dialCode: "241" },
  { name: "Gambia", iso2: "GM", dialCode: "220" },
  { name: "Georgia (საქართველო)", iso2: "GE", dialCode: "995" },
  { name: "Germany (Deutschland)", iso2: "DE", dialCode: "49" },
  { name: "Ghana (Gaana)", iso2: "GH", dialCode: "233" },
  { name: "Gibraltar", iso2: "GI", dialCode: "350" },
  { name: "Greece (Ελλάδα)", iso2: "GR", dialCode: "30" },
  { name: "Greenland (Kalaallit Nunaat)", iso2: "GL", dialCode: "299" },
  { name: "Grenada", iso2: "GD", dialCode: "1473" },
  { name: "Guadeloupe", iso2: "GP", dialCode: "590" },
  { name: "Guam", iso2: "GU", dialCode: "1671" },
  { name: "Guatemala", iso2: "GT", dialCode: "502" },
  { name: "Guernsey", iso2: "GG", dialCode: "44" },
  { name: "Guinea (Guinée)", iso2: "GN", dialCode: "224" },
  { name: "Guinea-Bissau (Guiné Bissau)", iso2: "GW", dialCode: "245" },
  { name: "Guyana", iso2: "GY", dialCode: "592" },
  { name: "Haiti", iso2: "HT", dialCode: "509" },
  { name: "Honduras", iso2: "HN", dialCode: "504" },
  { name: "Hong Kong (香港)", iso2: "HK", dialCode: "852" },
  { name: "Hungary (Magyarország)", iso2: "HU", dialCode: "36" },
  { name: "Iceland (Ísland)", iso2: "IS", dialCode: "354" },
  { name: "India (भारत)", iso2: "IN", dialCode: "91" },
  { name: "Indonesia", iso2: "ID", dialCode: "62" },
  { name: "Iran (‫ایران‬‎)", iso2: "IR", dialCode: "98" },
  { name: "Iraq (‫العراق‬‎)", iso2: "IQ", dialCode: "964" },
  { name: "Ireland", iso2: "IE", dialCode: "353" },
  { name: "Isle of Man", iso2: "IM", dialCode: "44" },
  { name: "Israel (‫ישראל‬‎)", iso2: "IL", dialCode: "972" },
  { name: "Italy (Italia)", iso2: "IT", dialCode: "39" },
  { name: "Jamaica", iso2: "JM", dialCode: "1876" },
  { name: "Japan (日本)", iso2: "JP", dialCode: "81" },
  { name: "Jersey", iso2: "JE", dialCode: "44" },
  { name: "Jordan (‫الأردن‬‎)", iso2: "JO", dialCode: "962" },
  { name: "Kazakhstan (Казахстан)", iso2: "KZ", dialCode: "7" },
  { name: "Kenya", iso2: "KE", dialCode: "254" },
  { name: "Kiribati", iso2: "KI", dialCode: "686" },
  { name: "Kosovo", iso2: "XK", dialCode: "383" },
  { name: "Kuwait (‫الكويت‬‎)", iso2: "KW", dialCode: "965" },
  { name: "Kyrgyzstan (Кыргызстан)", iso2: "KG", dialCode: "996" },
  { name: "Laos (ລາວ)", iso2: "LA", dialCode: "856" },
  { name: "Latvia (Latvija)", iso2: "LV", dialCode: "371" },
  { name: "Lebanon (‫لبنان‬‎)", iso2: "LB", dialCode: "961" },
  { name: "Lesotho", iso2: "LS", dialCode: "266" },
  { name: "Liberia", iso2: "LR", dialCode: "231" },
  { name: "Libya (‫ليبيا‬‎)", iso2: "LY", dialCode: "218" },
  { name: "Liechtenstein", iso2: "LI", dialCode: "423" },
  { name: "Lithuania (Lietuva)", iso2: "LT", dialCode: "370" },
  { name: "Luxembourg", iso2: "LU", dialCode: "352" },
  { name: "Macau (澳門)", iso2: "MO", dialCode: "853" },
  { name: "Macedonia (FYROM) (Македонија)", iso2: "MK", dialCode: "389" },
  { name: "Madagascar (Madagasikara)", iso2: "MG", dialCode: "261" },
  { name: "Malawi", iso2: "MW", dialCode: "265" },
  { name: "Malaysia", iso2: "MY", dialCode: "60" },
  { name: "Maldives", iso2: "MV", dialCode: "960" },
  { name: "Mali", iso2: "ML", dialCode: "223" },
  { name: "Malta", iso2: "MT", dialCode: "356" },
  { name: "Marshall Islands", iso2: "MH", dialCode: "692" },
  { name: "Martinique", iso2: "MQ", dialCode: "596" },
  { name: "Mauritania (‫موريتانيا‬‎)", iso2: "MR", dialCode: "222" },
  { name: "Mauritius (Moris)", iso2: "MU", dialCode: "230" },
  { name: "Mayotte", iso2: "YT", dialCode: "262" },
  { name: "Mexico (México)", iso2: "MX", dialCode: "52" },
  { name: "Micronesia", iso2: "FM", dialCode: "691" },
  { name: "Moldova (Republica Moldova)", iso2: "MD", dialCode: "373" },
  { name: "Monaco", iso2: "MC", dialCode: "377" },
  { name: "Mongolia (Монгол)", iso2: "MN", dialCode: "976" },
  { name: "Montenegro (Crna Gora)", iso2: "ME", dialCode: "382" },
  { name: "Montserrat", iso2: "MS", dialCode: "1664" },
  { name: "Morocco (‫المغرب‬‎)", iso2: "MA", dialCode: "212" },
  { name: "Mozambique (Moçambique)", iso2: "MZ", dialCode: "258" },
  { name: "Myanmar (Burma) (မြန်မာ)", iso2: "MM", dialCode: "95" },
  { name: "Namibia (Namibië)", iso2: "NA", dialCode: "264" },
  { name: "Nauru", iso2: "NR", dialCode: "674" },
  { name: "Nepal (नेपाल)", iso2: "NP", dialCode: "977" },
  { name: "Netherlands (Nederland)", iso2: "NL", dialCode: "31" },
  { name: "New Caledonia (Nouvelle-Calédonie)", iso2: "NC", dialCode: "687" },
  { name: "New Zealand", iso2: "NZ", dialCode: "64" },
  { name: "Nicaragua", iso2: "NI", dialCode: "505" },
  { name: "Niger (Nijar)", iso2: "NE", dialCode: "227" },
  { name: "Nigeria", iso2: "NG", dialCode: "234" },
  { name: "Niue", iso2: "NU", dialCode: "683" },
  { name: "Norfolk Island", iso2: "NF", dialCode: "672" },
  {
    name: "North Korea (조선 민주주의 인민 공화국)",
    iso2: "KP",
    dialCode: "850"
  },
  { name: "Northern Mariana Islands", iso2: "MP", dialCode: "1670" },
  { name: "Norway (Norge)", iso2: "NO", dialCode: "47" },
  { name: "Oman (‫عُمان‬‎)", iso2: "OM", dialCode: "968" },
  { name: "Pakistan (‫پاکستان‬‎)", iso2: "PK", dialCode: "92" },
  { name: "Palau", iso2: "PW", dialCode: "680" },
  { name: "Palestine (‫فلسطين‬‎)", iso2: "PS", dialCode: "970" },
  { name: "Panama (Panamá)", iso2: "PA", dialCode: "507" },
  { name: "Papua New Guinea", iso2: "PG", dialCode: "675" },
  { name: "Paraguay", iso2: "PY", dialCode: "595" },
  { name: "Peru (Perú)", iso2: "PE", dialCode: "51" },
  { name: "Philippines", iso2: "PH", dialCode: "63" },
  { name: "Poland (Polska)", iso2: "PL", dialCode: "48" },
  { name: "Portugal", iso2: "PT", dialCode: "351" },
  { name: "Puerto Rico", iso2: "PR", dialCode: "1" },
  { name: "Qatar (‫قطر‬‎)", iso2: "QA", dialCode: "974" },
  { name: "Réunion (La Réunion)", iso2: "RE", dialCode: "262" },
  { name: "Romania (România)", iso2: "RO", dialCode: "40" },
  { name: "Russia (Россия)", iso2: "RU", dialCode: "7" },
  { name: "Rwanda", iso2: "RW", dialCode: "250" },
  { name: "Saint Barthélemy", iso2: "BL", dialCode: "590" },
  { name: "Saint Helena", iso2: "SH", dialCode: "290" },
  { name: "Saint Kitts and Nevis", iso2: "KN", dialCode: "1869" },
  { name: "Saint Lucia", iso2: "LC", dialCode: "1758" },
  {
    name: "Saint Martin (Saint-Martin (partie française))",
    iso2: "MF",
    dialCode: "590"
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    iso2: "PM",
    dialCode: "508"
  },
  { name: "Saint Vincent and the Grenadines", iso2: "VC", dialCode: "1784" },
  { name: "Samoa", iso2: "WS", dialCode: "685" },
  { name: "San Marino", iso2: "SM", dialCode: "378" },
  {
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    iso2: "ST",
    dialCode: "239"
  },
  {
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    iso2: "SA",
    dialCode: "966"
  },
  { name: "Senegal (Sénégal)", iso2: "SN", dialCode: "221" },
  { name: "Serbia (Србија)", iso2: "RS", dialCode: "381" },
  { name: "Seychelles", iso2: "SC", dialCode: "248" },
  { name: "Sierra Leone", iso2: "SL", dialCode: "232" },
  { name: "Singapore", iso2: "SG", dialCode: "65" },
  { name: "Sint Maarten", iso2: "SX", dialCode: "1721" },
  { name: "Slovakia (Slovensko)", iso2: "SK", dialCode: "421" },
  { name: "Slovenia (Slovenija)", iso2: "SI", dialCode: "386" },
  { name: "Solomon Islands", iso2: "SB", dialCode: "677" },
  { name: "Somalia (Soomaaliya)", iso2: "SO", dialCode: "252" },
  { name: "South Africa", iso2: "ZA", dialCode: "27" },
  { name: "South Korea (대한민국)", iso2: "KR", dialCode: "82" },
  { name: "South Sudan (‫جنوب السودان‬‎)", iso2: "SS", dialCode: "211" },
  { name: "Spain (España)", iso2: "ES", dialCode: "34" },
  { name: "Sri Lanka (ශ්‍රී ලංකාව)", iso2: "LK", dialCode: "94" },
  { name: "Sudan (‫السودان‬‎)", iso2: "SD", dialCode: "249" },
  { name: "Suriname", iso2: "SR", dialCode: "597" },
  { name: "Svalbard and Jan Mayen", iso2: "SJ", dialCode: "47" },
  { name: "Swaziland", iso2: "SZ", dialCode: "268" },
  { name: "Sweden (Sverige)", iso2: "SE", dialCode: "46" },
  { name: "Switzerland (Schweiz)", iso2: "CH", dialCode: "41" },
  { name: "Syria (‫سوريا‬‎)", iso2: "SY", dialCode: "963" },
  { name: "Taiwan (台灣)", iso2: "TW", dialCode: "886" },
  { name: "Tajikistan", iso2: "TJ", dialCode: "992" },
  { name: "Tanzania", iso2: "TZ", dialCode: "255" },
  { name: "Thailand (ไทย)", iso2: "TH", dialCode: "66" },
  { name: "Timor-Leste", iso2: "TL", dialCode: "670" },
  { name: "Togo", iso2: "TG", dialCode: "228" },
  { name: "Tokelau", iso2: "TK", dialCode: "690" },
  { name: "Tonga", iso2: "TO", dialCode: "676" },
  { name: "Trinidad and Tobago", iso2: "TT", dialCode: "1868" },
  { name: "Tunisia (‫تونس‬‎)", iso2: "TN", dialCode: "216" },
  { name: "Turkey (Türkiye)", iso2: "TR", dialCode: "90" },
  { name: "Turkmenistan", iso2: "TM", dialCode: "993" },
  { name: "Turks and Caicos Islands", iso2: "TC", dialCode: "1649" },
  { name: "Tuvalu", iso2: "TV", dialCode: "688" },
  { name: "U.S. Virgin Islands", iso2: "VI", dialCode: "1340" },
  { name: "Uganda", iso2: "UG", dialCode: "256" },
  { name: "Ukraine (Україна)", iso2: "UA", dialCode: "380" },
  {
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    iso2: "AE",
    dialCode: "971"
  },
  { name: "United Kingdom", iso2: "GB", dialCode: "44" },
  { name: "United States", iso2: "US", dialCode: "1" },
  { name: "Uruguay", iso2: "UY", dialCode: "598" },
  { name: "Uzbekistan (Oʻzbekiston)", iso2: "UZ", dialCode: "998" },
  { name: "Vanuatu", iso2: "VU", dialCode: "678" },
  { name: "Vatican City (Città del Vaticano)", iso2: "VA", dialCode: "39" },
  { name: "Venezuela", iso2: "VE", dialCode: "58" },
  { name: "Vietnam (Việt Nam)", iso2: "VN", dialCode: "84" },
  { name: "Wallis and Futuna (Wallis-et-Futuna)", iso2: "WF", dialCode: "681" },
  { name: "Western Sahara (‫الصحراء الغربية‬‎)", iso2: "EH", dialCode: "212" },
  { name: "Yemen (‫اليمن‬‎)", iso2: "YE", dialCode: "967" },
  { name: "Zambia", iso2: "ZM", dialCode: "260" },
  { name: "Zimbabwe", iso2: "ZW", dialCode: "263" },
  { name: "Åland Islands", iso2: "AX", dialCode: "358" }
];
